<div class="form-container company-detail-form-container">
  <div>
    <h2>Company Detail</h2>
  </div>
  @if (messages.length > 0) {
    <div>
      @for (m of messages; track m; let i = $index) {
        <p-message
          [severity]="asMessageSeverity(m.severity)"
          >{{ m.summary ? (m.detail ? m.summary + ': ' + m.detail : m.summary) : m.detail }}
        </p-message>
      }
    </div>
  }
  @if (vm$ | async; as vm) {
    <div>
      <div class="grid">
        <!-- Company Properties -->
        <div class="col-12">
          <div class="grid formgrid p-fluid">
            <!-- Name -->
            <div class="col-3 field">
              <label>Name</label>
            </div>
            <div class="col-9 field">
              <input type="text" pInputText placeholder="Enter Company Name" [(ngModel)]="company.name" />
              @if (modelInvalid && !company.name) {
                <div>
                  <small class="p-error">Name is required!</small>
                </div>
              }
            </div>
            <!-- Prefix -->
            <div class="col-3 field">
              <label>Prefix</label>
            </div>
            <div class="col-9 field">
              <input type="text" pInputText placeholder="Enter Company Prefix" [(ngModel)]="company.prefix" />
            </div>
            <!-- Company Type -->
            <div class="col-3 field">
              <label>Company Type</label>
            </div>
            <div class="col-9 field">
              <p-select [options]="companyTypes" placeholder="Select Company Type"
                [(ngModel)]="company.companyType"
              class="w-full"></p-select>
              @if (modelInvalid && !company.companyType) {
                <div>
                  <small class="p-error">Company Type is required!</small>
                </div>
              }
            </div>
            <!-- <div class="col-3 field">
            <label>OFS Shared With</label>
          </div>
          <div class="col-9 field">
            <p-multiSelect [options]="serviceProviderOptions" placeholder="Service Providers"
            [(ngModel)]="company.serviceProviderIds" class="w-full"></p-multiSelect>
          </div>
          <div class="col-3 field">
            <label>Slack Webhook</label>
          </div>
          <div class="col-9 field">
            <input type="text" pInputText placeholder="Enter Slack Webhook" [(ngModel)]="company.slackWebhook"
              pTooltip="Optional. Integrate messages with your company's Slack account." />
            </div>
            <div class="col-3 field">
              <label>Auto Approved Email Domains</label>
            </div>
            <div class="col-9 field">
              <input type="text" pInputText placeholder="Enter Email Domains (separated by semicolon)"
                [(ngModel)]="autoApprovedEmailDomains" (change)="updateEmailDomains()"
                pTooltip="Email domains separated by a semicolon that will auto approve user requests coming from users whose sign in id is part of the listed domains." />
              </div> -->
              <!-- Api Key -->
              <div class="col-3 field">
                <label>Api Key</label>
                <button pButton class="p-button-text" (click)="showApiHelp()"
                  pTooltip="View API Documentation">
                  <i pButtonIcon class="pi pi-question-circle"></i>
                </button>
              </div>
              <div class="col-7 field">
                <input type="text" pInputText placeholder="Generate API Key" disabled="true"
                  [(ngModel)]="company.apiKey" />
                </div>
                <div class="col-2 field">
                  <button pButton (click)="generateApiKey()"
                    pTooltip="Generate a new ApiKey">
                    <span pButtonLabel>Generate</span>
                  </button>
                </div>
              </div>
            </div>
            <div class="col-12">
              <p-accordion value="workbook">
                <!-- Workbook Configuration -->
                @if (!isNew) {
                  <p-accordion-panel value="workbook">
                    <p-accordion-header>Workbook Configuration</p-accordion-header>
                    <p-accordion-content>
                      <div class="grid formgrid">
                        <!-- Enable Workbook Features -->
                        <!-- <div class="col-3">
                        <label>Enable New Workbook Features?</label>
                      </div>
                      <div class="col-9"
                        pTooltip="Check this option to configure the company for the new Company Configuration and Offline Workbook Feature.  All NEW jobs will use this feature if checked.">
                        <p-checkbox [(ngModel)]="company.enableOfflineWorkbook" binary="true" [disabled]="true">
                        </p-checkbox>
                      </div> -->
                      <!-- Company Unit System -->
                      <div class="col-3">
                        <label>Company Unit System</label>
                      </div>
                      <div class="col-3">
                        <p-select [options]="workbookConfigurationUnitSystemChoices"
                          placeholder="Select Company Unit System" [(ngModel)]="company.unitSystem"
                        class="w-full"></p-select>
                      </div>
                      <div class="col-6">
                        @if (isAdmin) {
                          <button pButton (click)="RecreateWorkbookConfiguration()"
                            [ngClass]="{ 'action-button': !saving, 'action-button-disabled': saving }"
                            [disabled]="saving">
                            <span pButtonLabel>Reset Configuration</span>
                          </button>
                        }
                      </div>
                    </div>
                    <div class="grid formgrid">
                      <div class="col-12">
                        <app-workbook-configuration [companyUnitSystem]="company.unitSystem ?? 'Imperial/US'" [companyId]="company.id ?? ''"
                          [showUnitSystemChoices]="false" (companyConfiguration)="updateWorkbookConfiguration($event)"
                          (errors)="handleErrors($event)">
                        </app-workbook-configuration>
                      </div>
                    </div>
                  </p-accordion-content>
                </p-accordion-panel>
              }
              <!-- Addresses -->
              <p-accordion-panel value="addresses">
                <p-accordion-header>Addresses</p-accordion-header>
                <p-accordion-content>
                  <div class="flex align-items-center gap-2">
                    <p-checkbox inputId="shippingSame" [(ngModel)]="shippingAddressIsTheSame" binary="true"></p-checkbox>
                    <label for="shippingSame">Shipping Address is the same as Billing Address</label>
                  </div>
                  <div class="grid field mt-3">
                    <div class="col-6">
                      <div>Billing Address</div>
                      <app-address [(ngModel)]="company.billingAddress"
                        (emailValid)="validateBillingEmail($event)">
                      </app-address>
                    </div>
                    <div class="col-6">
                      <!-- Shipping Address -->
                      @if (!shippingAddressIsTheSame) {
                        <div>
                          <div>Shipping Address</div>
                          <app-address [(ngModel)]="company.shippingAddress"
                          (emailValid)="validateShippingEmail($event)"></app-address>
                        </div>
                      }
                    </div>
                  </div>
                </p-accordion-content>
              </p-accordion-panel>
            </p-accordion>
          </div>
          <!-- Action Buttons -->
          <div class="col-12">
            @if (isNew) {
<button pButton class="ui-button-primary m-2" (click)="saveCompany()" [ngClass]="{ 'action-button': !saving,
                                 'action-button-disabled': saving }" [disabled]="saving">Create
              </button>
            }
            @if (!isNew) {
<button pButton class="ui-button-primary m-2" (click)="saveCompany()" [ngClass]="{ 'action-button': !saving,
                                 'action-button-disabled': saving }" [disabled]="saving">Update
              </button>
            }
            <button pButton class="action-button m-2" (click)="returnToCompanyList()">Cancel
            </button>
          </div>
        </div>
        <!--Invalid Model Dialog-->
        <p-dialog header="Cannot Save Changes" [(visible)]="showModelInvalidDialog" [modal]="true"
          [style]="{width: '350px'}" [minY]="70" [baseZIndex]="999" [autoZIndex]="false" [dismissableMask]="true">
          <span>
            One or more fields is empty or invalid. Please correct and try again.
          </span>
          <p-footer>
            <button type="button" pButton (click)="closeInvalidModelDialog()">
              <i pButtonIcon class="fa-check"></i>
              <span pButtonLabel>Ok</span>
            </button>
          </p-footer>
        </p-dialog>
      </div>
    }
